import type { KyInstance } from 'ky';

import { ensureError, formatString, isNotDefined } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Deletes a comment from a specific mailing list.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param mailingListId - The unique identifier of the mailing list.
 * @param commentId - The unique identifier of the comment to be deleted.
 * @returns A promise that resolves to an {@link OperationResult} indicating the outcome of the delete operation.
 * @throws Will throw an error if the HTTP request fails.
 */
export const deleteMailingListComment = async (instance: KyInstance, mailingListId?: number, commentId?: number) => {
  try {
    if (isNotDefined(mailingListId) || isNotDefined(commentId)) {
      throw new Error('Mailing List ID and Comment ID must be provided to delete a mailing list comment.');
    }

    return await instance
      .delete<OperationResult>(
        formatString(Uri.mailingList.deleteMailingListComment, mailingListId.toString(), commentId.toString())
      )
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
